import posthog from 'posthog-js';

export const posthog_api_key = 'phc_E7ZZJ6g6bxVfbXHXCGMhJoE257tTURmxcLHe4G2HmUO';

export default posthog;
